(() => {
  if (customElements.get('b-generations')) return;

  class BGenerations extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.boundResize = this.debounce(this.handleResize.bind(this), 150);
      this.sectionLoadHandler = this.handleSectionLoad.bind(this);
      this.blockSelectHandler = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.swiperElement = this.querySelector('.b-gens__swiper');
      this.prevEl = this.querySelector('.b-gens__nav-btn--prev');
      this.nextEl = this.querySelector('.b-gens__nav-btn--next');
      this.mobileBreakpoint = parseInt(this.dataset.mobileBreakpoint || '767', 10);

      document.addEventListener('shopify:section:load', this.sectionLoadHandler);
      document.addEventListener('shopify:block:select', this.blockSelectHandler);

      this.waitForSwiper(() => {
        this.handleResize();
        window.addEventListener('resize', this.boundResize, { passive: true });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundResize);
      document.removeEventListener('shopify:section:load', this.sectionLoadHandler);
      document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      this.destroySwiper();
    }

    debounce(fn, wait) {
      let timer = null;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), wait);
      };
    }

    waitForSwiper(callback, retry = 0) {
      if (typeof window.Swiper === 'function') {
        callback();
        return;
      }
      if (retry > 30) return;
      setTimeout(() => this.waitForSwiper(callback, retry + 1), 120);
    }

    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint;
    }

    handleResize() {
      if (!this.swiperElement) return;
      this.destroySwiper();
      this.initSwiper();
    }

    initSwiper() {
      if (this.swiperInstance || typeof window.Swiper !== 'function') return;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobile = this.isMobile();

      const navigation =
        this.prevEl && this.nextEl
          ? {
              prevEl: this.prevEl,
              nextEl: this.nextEl,
              disabledClass: 'swiper-button-disabled'
            }
          : undefined;

      this.swiperInstance = new window.Swiper(this.swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchOverflow: true,
        speed: prefersReducedMotion ? 0 : 500,
        grabCursor: true,
        centeredSlides: mobile,
        centeredSlidesBounds: false,
        resistanceRatio: 0.65,
        navigation,
        a11y: {
          enabled: true
        }
      });
    }

    destroySwiper() {
      if (!this.swiperInstance) return;
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    handleSectionLoad(event) {
      const sectionId = this.dataset.sectionId;
      if (!sectionId || !event?.detail?.sectionId) return;
      if (String(event.detail.sectionId) !== String(sectionId)) return;
      this.handleResize();
    }

    handleBlockSelect(event) {
      const sectionId = this.dataset.sectionId;
      if (!sectionId || !event?.detail?.sectionId) return;
      if (String(event.detail.sectionId) !== String(sectionId)) return;
      if (!this.swiperInstance) return;

      const blockId = event.detail.blockId;
      if (!blockId) return;

      const slides = this.querySelectorAll('.b-gens__slide[data-block-id]');
      let index = -1;
      slides.forEach((slide, i) => {
        if (slide.getAttribute('data-block-id') === blockId) index = i;
      });
      if (index >= 0) this.swiperInstance.slideTo(index);
    }
  }

  customElements.define('b-generations', BGenerations);
})();
